var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.365 15.7237H5.635C2.1525 15.7237 1.09375 14.665 1.09375 11.1825V5.635C1.09375 2.1525 2.1525 1.09375 5.635 1.09375H15.3563C18.8388 1.09375 19.8975 2.1525 19.8975 5.635V11.1737C19.9063 14.665 18.8475 15.7237 15.365 15.7237ZM5.635 2.40625C2.8875 2.40625 2.40625 2.8875 2.40625 5.635V11.1737C2.40625 13.9213 2.8875 14.4025 5.635 14.4025H15.3563C18.1038 14.4025 18.585 13.9213 18.585 11.1737V5.635C18.585 2.8875 18.1038 2.40625 15.3563 2.40625H5.635Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.9061C10.1413 19.9061 9.84375 19.6086 9.84375 19.2499V15.0674C9.84375 14.7086 10.1413 14.4111 10.5 14.4111C10.8587 14.4111 11.1562 14.7086 11.1562 15.0674V19.2499C11.1562 19.6086 10.8587 19.9061 10.5 19.9061Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 12.0312H1.75C1.39125 12.0312 1.09375 11.7337 1.09375 11.375C1.09375 11.0163 1.39125 10.7188 1.75 10.7188H19.25C19.6088 10.7188 19.9063 11.0163 19.9063 11.375C19.9063 11.7337 19.6088 12.0312 19.25 12.0312Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 19.9062H6.5625C6.20375 19.9062 5.90625 19.6087 5.90625 19.25C5.90625 18.8913 6.20375 18.5938 6.5625 18.5938H14.4375C14.7963 18.5938 15.0938 18.8913 15.0938 19.25C15.0938 19.6087 14.7963 19.9062 14.4375 19.9062Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogHistory);
export default __webpack_public_path__ + "static/media/log-history.c967aa7136b84dfc00c724d464d7a9aa.svg";
export { ForwardRef as ReactComponent };